"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("./colors"));
const palette = {
    common: {
        black: colors_1.default.black,
        white: colors_1.default.white,
    },
    primary: {
        light: colors_1.default.lightOrange,
        main: colors_1.default.orange,
        dark: colors_1.default.darkOrange,
        contrastText: colors_1.default.black,
    },
    secondary: {
        light: colors_1.default.lightViolet,
        main: colors_1.default.violet,
        dark: colors_1.default.darkViolet,
        contrastText: colors_1.default.butter,
    },
    error: {
        main: colors_1.default.burgundy,
    },
    grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
        A100: '#d5d5d5',
        A200: '#aaaaaa',
        A400: '#303030',
        A700: '#616161',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
    },
    background: {
        paper: '#fff',
        default: '#fafafa',
    },
    action: {
        active: 'rgba(0, 0, 0, 0.54)',
        hover: 'rgba(0, 0, 0, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(0, 0, 0, 0.14)',
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
    },
    mode: 'light',
};
exports.default = palette;
//# sourceMappingURL=palette.js.map